import type { OnboardingStep } from 'modules/main/domain/interfaces/onboarding-step';
import { Pages } from 'modules/navigation/domain/enums/pages';

export const steps: OnboardingStep[] = [
  {
    emoji: '🏃🏃‍♀️🏃🏻‍♂️',
    header: 'Создай команду',
    action: 'Создать',
    to: Pages.TEAMS.CREATE,
    checkProperty: 'stepper:main:createTeam',
  },
  {
    emoji: '🏋️‍♂️️️',
    header: 'Добавь игроков',
    action: 'Добавить',
    to: Pages.PLAYERS.CREATE,
    checkProperty: 'stepper:main:createPlayer',
  },
  {
    emoji: '🏆',
    header: 'Создай турнир',
    action: 'Создать',
    to: Pages.CHAMPIONSHIPS.CREATE,
    checkProperty: 'stepper:main:createTournament',
  },
  {
    emoji: '🗒️️️',
    header: 'Заяви команду',
    action: 'Заявить',
    to: Pages.TEAMS.INDEX,
    checkProperty: 'stepper:main:applicationTeam',
  },
  {
    emoji: '📆️',
    header: 'Запусти турнир',
    action: 'Запустить',
    to: Pages.CHAMPIONSHIPS.INDEX,
    checkProperty: 'stepper:main:startTournament',
  },
  {
    emoji: '📱️',
    header: 'Управляй',
    action: 'Начать',
    to: Pages.SCHEDULE.INDEX,
    checkProperty: 'stepper:main:manageTournament',
  },
];
